import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Button, Container, Grid, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProjectMain from "./project/ProjectMain";
import { t } from "i18next";
import DatasetTable from "./dataset/DatasetTable";
import DatasetMain from "./dataset/DatasetMain";
import ServerPage from "../pages/ServerPage";
import InspStatusPage from "../pages/InspStatusPage.js";
import InspStatusMain from "./inspStatus/InspStatusMain";
import InspStatusReportPage from "./inspStatusReport/InspStatusReportPage.js";
import TestPage from "./testOpenCV/TestPage";
import InspModelPage from "../pages/InspModelPage";
import InspRuleMain from "./inspRule/InspRuleMain";
import ServerManageMain from "./serverManage/ServerManageMain";
import NoticePage from "./notice/NoticePage";

export default function HomeTab() {
  const location = useLocation();
  const [value, setValue] = useState<string>(location.state?.tab || "project_list");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange}>
            <Tab label={t("Project")} sx={{ color: "var(--text-color)" }} value="project_list" />
            <Tab label={t("Train")} sx={{ color: "var(--text-color)" }} value="train_list" />
            <Tab label={t("Dataset")} sx={{ color: "var(--text-color)" }} value="dataset_list" />
            <Tab label={t("ServerStatus")} sx={{ color: "var(--text-color)" }} value="server_status" />
            <Tab label={t("InspModel")} sx={{ color: "var(--text-color)" }} value="insp_model" />
            <Tab label={t("InspRule")} sx={{ color: "var(--text-color)" }} value="insp_rule" />
            <Tab label={t("InspStatus")} sx={{ color: "var(--text-color)" }} value="insp_status" />
            <Tab label={t("InspStatusReport")} sx={{ color: "var(--text-color)" }} value="insp_status_report" />
            <Tab label={t("ServerManage")} sx={{ color: "var(--text-color)" }} value="server_manage" />
            <Tab label={t("Notice")} sx={{ color: "var(--text-color)" }} value="notice" />
            <Tab label={t("test")} sx={{ color: "var(--text-color)" }} value="test" />
          </TabList>
        </Box>
        <TabPanel value="project_list" sx={{ position: "relative" }}>
          <ProjectMain />
        </TabPanel>

        <TabPanel value="dataset_list">
          <DatasetMain />
        </TabPanel>
        <TabPanel value="insp_model">
          <InspModelPage />
        </TabPanel>
        <TabPanel value="insp_rule">
          <InspRuleMain />
        </TabPanel>
        <TabPanel value="server_status">
          <ServerPage />
        </TabPanel>
        <TabPanel value="insp_status">
          <InspStatusMain />
        </TabPanel>
        <TabPanel value="insp_status_report">
          <InspStatusReportPage />
        </TabPanel>
        <TabPanel value="server_manage">
          <ServerManageMain />
        </TabPanel>
        <TabPanel value="notice">
          <NoticePage />
        </TabPanel>
        <TabPanel value="test">
          <TestPage />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
